<template>
    <div>
        <div class="row ml-0">
            <h6>Programs {{current_module.courses.length}}</h6>
            <div class="put_content_right">
                <!-- <button class="button-sme mb-0">
                        <img width="15" src="../../../assets/images/icons/solid/Add.svg" />
                </button> -->
                <b-button v-b-toggle.collapse-1 :disabled="current_module.courses.length == 0">
                    <i class="fa fa-expand">
                    </i>
                </b-button>
            </div>
        </div>
            <b-collapse id="collapse-1" class="mt-2" >
                <b-card  v-for="(prg, index) in current_module.courses" :key="index">

                <p @click="openInNewTab(prg.id, 'edit')" class="progamClickable card-text" :style="{color : blue_color}">{{prg.id + ' - ' + prg.name}}</p>

                </b-card>
            </b-collapse>

     <hr>
        <div class="row ml-0">
            <h6>Agencies {{organizationLength}}</h6>
            <div class="put_content_right">
                <!-- <button class="button-sme mb-0">
                        <img width="15" src="../../../assets/images/icons/solid/Add.svg" />
                </button> -->
                <b-button v-b-toggle.collapse-2 :disabled="organizationLength == 0">
                    <i class="fa fa-expand">
                    </i>
                </b-button>
            </div>
        </div>
            <b-collapse id="collapse-2" class="mt-2">
                <b-card v-for="(org, index) in current_module.organizations" :key="index" >
                <p class="card-text" :style="{color : blue_color}">{{org.id + ' - ' + org.name}}</p>
                </b-card>
            </b-collapse>
    <hr>
     <div class="row ml-0">
            <h6> Clones <span v-if="current_module.is_master">(Master Module)</span> {{current_module.clones_count}}</h6>
            <div class="put_content_right">
                <!-- <button class="button-sme mb-0">
                        <img width="15" src="../../../assets/images/icons/solid/Add.svg" />
                </button> -->
                <b-button v-b-toggle.collapse-3 :disabled="current_module.clones_count == 0">
                    <i class="fa fa-expand">
                    </i>
                </b-button>
            </div>
        </div>
            <b-collapse id="collapse-3" class="mt-2">
                <b-card v-for="(clone) in current_module.clones" :key="clone.id" >
                    	 <router-link tag="a" :to="{name: 'sme.module.view', params:{id: clone.id.toString()}}" target="_blank">
							<p class="card-text" :style="{color : blue_color}">{{clone.title}}</p>
					    </router-link>
                </b-card>
            </b-collapse>
    </div>
</template>
<script>
export default{
    props:['current_module','organizationLength'],
    data: function(){
        return{
            blue_color:'#11A5A7',
            visible_program:false
        }
    },
    methods: {
        openInNewTab(objectID, objectType) {
            var base_url = window.location.origin;

            window.open(
                base_url + "/s/" + objectID + "/" + objectType
            );
        },
    }
}
</script>
<style>
.put_content_right{
    margin-left:auto;
}

.progamClickable:hover {
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/sme/SharedViews/ProgramAgencyCollapse.vue